import React, { memo } from "react";
import "./AnimatedShinyText.css";

export const AnimatedShinyText = memo(({
  children,
  className = "",
  shimmerWidth = 100,
  ...props
}) => {
  return (
    <span
      style={{
        "--shiny-width": `${shimmerWidth}px`,
      }}
      className={`animated-shiny-text ${className}`}
      {...props}
    >
      {children}
    </span>
  );
});

AnimatedShinyText.displayName = "AnimatedShinyText";
